import { render, staticRenderFns } from "./InReview.vue?vue&type=template&id=4470000c&scoped=true&"
import script from "./InReview.vue?vue&type=script&lang=js&"
export * from "./InReview.vue?vue&type=script&lang=js&"
import style0 from "./InReview.vue?vue&type=style&index=0&id=4470000c&prod&lang=scss&"
import style1 from "./InReview.vue?vue&type=style&index=1&id=4470000c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4470000c",
  null
  
)

export default component.exports